import { render, staticRenderFns } from "./dowBox.vue?vue&type=template&id=705fa200&scoped=true&"
import script from "./dowBox.vue?vue&type=script&lang=js&"
export * from "./dowBox.vue?vue&type=script&lang=js&"
import style0 from "./dowBox.vue?vue&type=style&index=0&id=705fa200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705fa200",
  null
  
)

export default component.exports